__turbopack_context__.v({
  "btn": "style-module-scss-module__4n1lVa__btn",
  "container": "style-module-scss-module__4n1lVa__container",
  "extra": "style-module-scss-module__4n1lVa__extra",
  "list": "style-module-scss-module__4n1lVa__list",
  "phone": "style-module-scss-module__4n1lVa__phone",
  "preheader": "style-module-scss-module__4n1lVa__preheader",
  "tooltip": "style-module-scss-module__4n1lVa__tooltip",
  "wrapper": "style-module-scss-module__4n1lVa__wrapper",
});
